import PropTypes from 'prop-types';
import { default as React } from 'react';
import LanguageSelector from '../LanguageSelector';
import TitledPanel from '../TitledPanel';
import { LANGS } from '../utils/constants';

function SelectDefaultLang(props) {

    const { onSelectLang, lang } = props;

    return (
        <TitledPanel title="Default Language">
            <LanguageSelector
                langs={Object.keys(LANGS)}
                defaultLang={lang}
                includeLabel={false}
                onSelect={onSelectLang} />
        </TitledPanel>
    );
}

SelectDefaultLang.propTypes = {
    onSelectLang: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired
};

export default SelectDefaultLang;